import { render } from "./IconEN.vue?vue&type=template&id=eb2b2716"
const script = {}
script.render = render

export default script